import TuneIcon from '@mui/icons-material/Tune'
import clsx from 'clsx'
import throttle from 'lodash/throttle.js'
import { type ChangeEventHandler, useId, useMemo, useRef } from 'react'
import { useActionCreators, useAppSelector } from 'shared/hooks'
import { contextActions } from 'shared/styles'
import * as Segmented from 'shared/ui/Segmented'

import type { Filter } from '../../model/types'

import Close from '../../../../assets/image/icons/buttons/close.svg'
import close from '../../../../assets/image/icons/svg/icons/Close-black.svg'
import { actions } from '../../model/slice.ts'
import { selectors } from '../../utils/selectors.ts'
import { FILTERS, TABS } from '../const.ts'
import css from './FilterForm.module.scss'
import { TempDebugButton } from './TempDebug.tsx'

export function FilterForm() {
	const id = useId()

	const filter = useAppSelector(selectors.filter),
		isSearchMode = useAppSelector(selectors.searchMode),
		showTabs = useAppSelector(selectors.withTabs)
	const { resetFilter, resetSearch, setFilter, setSearch } =
		useActionCreators(actions)

	const onInputChange: ChangeEventHandler<HTMLInputElement> = useMemo(
		() => throttle(event => setSearch(event.target.value), 800),
		[setSearch]
	)

	const ref = useRef<HTMLFormElement | null>(null)

	const shouldShowFilterButton =
		!isSearchMode &&
		(filter === 'unread' ||
			filter === 'in-mail' ||
			filter === 'archive' ||
			filter === 'my-connections' ||
			filter === 'starred' ||
			filter === 'spam')

	return (
		<form
			className={css.root}
			onChange={event => {
				const form = event.currentTarget
				const input = event.target

				if (input instanceof HTMLInputElement) {
					if (input.name === 'filter') {
						form.reset()
						setFilter(input.value as Filter)
					}
				}
				// if (input.name === 'search') {

				// }
			}}
			onReset={resetSearch as () => void}
		>
			<div className={css.fieldWrapper}>
				<input
					className={css.field}
					name='search'
					onChange={onInputChange}
					placeholder='Search'
					type='text'
				/>
				<button className={css.reset} type='reset'>
					<img alt='close' src={Close} />
				</button>

				<button
					className={css.trigger}
					// @ts-ignore
					popovertarget={id}
					popovertargetaction='toggle'
					type='button'
				>
					<TuneIcon />
				</button>
			</div>

			{shouldShowFilterButton && (
				<button
					className={css.tag}
					onClick={resetFilter as () => void}
					type='reset'
				>
					<img alt='close' src={close} />
					{filter}
				</button>
			)}

			<div
				className={clsx(css.filters, contextActions.menu)}
				id={id}
				// @ts-ignore Recheck in React 19
				popover='auto'
			>
				{FILTERS.map(({ icon, key, title }, index) => (
					<button
						autoFocus={index === 0}
						className={clsx(css.filter, contextActions.action)}
						key={key}
						onClick={() => {
							setFilter(key)
							ref.current?.reset()
						}}
						type='button'
					>
						<img alt='filterIcon' height={18} src={icon} width={18} />
						{title}
					</button>
				))}
			</div>

			{showTabs && (
				<Segmented.Radios className={css.tabs}>
					{TABS.map(({ label, value }) => (
						<Segmented.Radio
							defaultChecked={filter === value}
							key={value}
							name='filter'
							value={value}
						>
							{label}
						</Segmented.Radio>
					))}
				</Segmented.Radios>
			)}
		</form>
	)
}
